import { useInitChannelTalk } from '@repo/channel-talk';
import { IS_KAKAO_APP } from '@repo/common-utils';
import { initializeReactNativeBridge, sendBznavNativeMessage, useUTM } from '@repo/platform';
import Script from 'next/script';
import React, { useEffect } from 'react';

import { openInExternalBrowser } from '@/components/tax-refund/common/utils/openKakaoTalk';
import { COMMON_PATHS } from '@/lib/constants/paths';
import { SERVICE_APP_ID } from '@/lib/constants/variables';
import { useFirebaseInit } from '@/lib/web/core/use-firebase';

export const DefaultActionScripts = () => {
  useFirebaseInit();
  useInitChannelTalk();
  useUTM();
  initializeReactNativeBridge(SERVICE_APP_ID);

  useEffect(() => {
    sendBznavNativeMessage('setSignInInitialRoute', { path: COMMON_PATHS.환급조회목록 });
    if (IS_KAKAO_APP) {
      openInExternalBrowser(window.location.href);
    }
  }, []);

  return (
    <>
      <Script id="microsoft-clarity">
        {`
        (function(c,l,a,r,i,t,y){
          c[a] = c[a] || function () {
            (c[a].q = c[a].q || []).push(arguments)
          };
          t=l.createElement(r);t.async=1;t.src='https://www.clarity.ms/tag/'+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "les8a7b23n");
      `}
      </Script>
      <Script src="//tenping.kr/scripts/cpa/tenping.cpa.V2_Domain.min.js" />
    </>
  );
};
